<template>
    <feedback-form ref="feedbackForm" :title="title" :description="description" :button="button" @send-form="submit"></feedback-form>
</template>

<script>
import FeedbackForm from "../../vue/FeedbackForm";
import ApiService from "../../api/api";

export default {
    name: "FamilytreeFeedback",
    props: ['title', 'description', 'button'],
    components: { FeedbackForm },
    methods: {
        submit: function(form) {
            return new Promise((resolve, reject) => {
                this.$loading(this.$optionsLoading);

                ApiService.post('/familytree/send-feedback', form)
                    .then((response) => {
                        this.$refs.feedbackForm.$emit('reset-form');

                        this.$appNotify.success(this.$lang('services.success'));

                        this.$router.go(-1);
                    })
                    .catch((error) => {
                        if(error.response.data.errors) {
                            this.$refs.feedbackForm.$emit('show-errors', error.response.data.errors);
                        } else {
                            this.$appNotify.error(this.$lang('services.error'));
                        }
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    });
            });
        }
    }
}
</script>
